import { createContext, useContext, useMemo } from "react";

/**
 * I18nProvider - Phase 1 uses a single locale ("en").
 * The provider is wired now so future locales are drop-in additions:
 * add a locale file + a locale switch. Zero refactor to consumers.
 */

const enLocale = {
  "app.name": "IC Bingo",
  "app.tagline": "Hotel Bingo Show Platform",

  // Home / Launcher
  "home.welcome": "Welcome",
  "home.pickModule": "Choose a show to run tonight",
  "home.startNew": "Start New Game",
  "home.resume": "Resume Previous Game",
  "home.openProjector": "Open Projector Window",
  "home.settings": "Settings & Branding",
  "home.deviceStatus": "Device linked",

  // Modules
  "module.bingo.name": "Bingo Show",
  "module.bingo.description":
    "Cinematic 90-ball hotel bingo show with special number reveals.",

  // Settings
  "settings.title": "Settings & Branding",
  "settings.tabs.branding": "Hotel Branding",
  "settings.tabs.lookFeel": "Look & Feel",
  "settings.tabs.audio": "Audio",
  "settings.tabs.gameDefaults": "Game Defaults",
  "settings.tabs.bingo": "Bingo Show",

  // Host
  "host.backToHome": "Back to Home",
  "host.openProjector": "Open Projector",

  // Projector
  "projector.welcome": "Welcome to Bingo Night",

  // Common
  "common.comingSoon": "Coming in the next step",
};

const I18nContext = createContext({ t: (k) => k, locale: "en" });

export function I18nProvider({ children, locale = "en" }) {
  const value = useMemo(() => {
    const dict = locale === "en" ? enLocale : enLocale;
    return {
      locale,
      t: (key, fallback) => dict[key] ?? fallback ?? key,
    };
  }, [locale]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
